import React from 'react';
import {message, Modal,Button} from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import { postFrom, config, transterQuery } from '../../axios';
import moment from 'moment';


export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableSelectedRows: [], //表格选中的行
            showJrApiLogModal:false,
            params: {
                tableName: "",
                rowId: -1,
                pageSize: 10,
            },
            inputSearchTerm: "175px", //查询条件宽度
        }
    }

    open(tableName,rowId){

        this.setState({showJrApiLogModal:true,
        params:{
            tableName,
            rowId,
            pageSize:10
        }},()=>{
            this.handleSearch();
        });
    }

    close(){
        this.setState({showJrApiLogModal:false});
    }


    handleSearch = (values = {}) => {   //表单搜索/分页
        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });
        postFrom({ url: config.API_jrapilog_findPage, data }).then(res => {
            this.setState({ tableData: res.records, current: res.current, tableTotal: res.total, tableLoading: false })
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }
    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            inputSearchTerm
        } = this.state;

        return (
            <Modal width={900}
                title="建融日志"
                visible={this.state.showJrApiLogModal}
                onCancel={ this.close.bind(this) }
                footer={<Button type="primary" onClick={
                    this.close.bind(this)
                }>关闭</Button>}>
                <PageWrap
                    loading={loading}
                >
                    {/*<SuperForm*/}
                    {/*    data={searchData(inputSearchTerm)}*/}
                    {/*    sumbit={this.handleSearch}*/}
                    {/*    addParams={'current'}*/}
                    {/*/>*/}
                    <TableDOM
                        columns={columns({ current })}
                        data={tableData}
                        loading={tableLoading}
                        total={tableTotal}
                        current={current}
                        onChange={this.handleSearch}
                    />
                </PageWrap>
            </Modal>
        )
    }

    handleSelectChange = (selectedRowKeys, selectedRows) => { //表格选中行
        this.setState({ tableSelectedRows: selectedRows });
    }
}

const searchData = (inputSearchTerm) => [

];
const columns = ({ current }) => [
    {
        title: '调用时间',
        dataIndex: 'callTime',
        render(text, record, index) {
            return <span>
                <div>{record.callTime ? moment(record.callTime).format('YYYY-MM-DD hh:mm:ss') : ""}</div>
            </span>
        }
    },
    {
        title: '接口名称',
        dataIndex: 'apiName',
        render(text, record, index) {
            return <span >
                <div>{record.apiName ? record.apiName : null}</div>
            </span>
        }
    },
    // {
    //     title: '接口请求头',
    //     dataIndex: 'header',
    //     render(text, record, index) {
    //         return <span >
    //             <div>{record.header ? record.header : null}</div>
    //         </span>
    //     }
    // },
    // {
    //     title: '接口参数',
    //     dataIndex: 'params',
    //     render(text, record, index) {
    //         return <span >
    //             <div>{record.params ? record.params : null}</div>
    //         </span>
    //     }
    // },
    // {
    //     title: '接口签名参数',
    //     dataIndex: 'signParam',
    //     render(text, record, index) {
    //         return <span >
    //             <div>{record.signParam ? record.signParam : null}</div>
    //         </span>
    //     }
    // },
    // {
    //     title: '接口签名',
    //     dataIndex: 'sign',
    //     render(text, record, index) {
    //         return <span >
    //             <div>{record.sign ? record.sign : null}</div>
    //         </span>
    //     }
    // },
    {
        title: '接口返回值',
        dataIndex: 'response',
        width: 350,
        render(text, record, index) {
            return <span >
                <div>{record.response ? record.response : null}</div>
            </span>
        }
    },
];



// WEBPACK FOOTER //
// ./src/page/Other/JrApiLog.js